<mat-progress-bar *ngIf="!finish" mode="indeterminate"></mat-progress-bar>
<table [dataSource]="data" class="mat-elevation-z8 site-content" mat-table>
    <ng-container matColumnDef="degree">
        <th *matHeaderCellDef mat-header-cell>{{'Degree' | translate}}</th>
        <td mat-cell *matCellDef="let data">
            <span class="dot color-{{data.degree}}"></span>
            <span class=center-container>
        <span class="degree-text">{{data.degree}}</span>
      </span>
        </td>
        <td *matFooterCellDef mat-footer-cell> &Sigma;</td>
    </ng-container>

    <ng-container matColumnDef="percent">
        <th mat-header-cell *matHeaderCellDef>TBSA (%)</th>
        <td *matCellDef="let data" [ngStyle]="{'color':finish? 'black':'#a2a8b2'}"
            mat-cell> {{data.percent}} </td>
        <td *matFooterCellDef [ngStyle]="{'color':finish? 'black':'#a2a8b2'}"
            mat-footer-cell> {{total}} </td>

    </ng-container>

    <!-- set footer for total amount-->
    <ng-container matColumnDef="parkland">
        <td *matFooterCellDef class="mobile-hide bold" mat-footer-cell>Parkland</td>
    </ng-container>

    <ng-container matColumnDef="parkland_value">
        <td *matFooterCellDef [ngStyle]="{'color':finish? 'black':'#a2a8b2'}"
            mat-footer-cell> {{parkland}} ml
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    <tr *matFooterRowDef="['parkland','parkland_value']" mat-footer-row></tr>
</table>
<div class="center-container version">
    <p>Version: {{version}}</p>
</div>


<!--
<div class="site-content center-container">
  <button mat-raised-button color="primary">Share</button>
</div>-->
